<template>
  <div id="modalAddSubUserBySupplier" class="modal fade">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-lg"
      role="document"
    >
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ item ? $t("subuser.修改角色") : $t("subuser.新建子账号") }}
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25">
          <form>
            <div class="form-group row">
              <label
                for="iptContact"
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
                >{{ $t("subuser.姓名：") }}</label
              >
              <div class="col-md-4 col-sm-12">
                <input
                  type="text"
                  name="name"
                  id="name"
                  class="form-control form-control-sm"
                  v-model="subuserData.name"
                />
              </div>
              <label
                for="iptPosition"
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
                >{{ $t("app.登录用户名：") }}</label
              >
              <div class="col-md-4 col-sm-12">
                <input
                  type="text"
                  name="username"
                  id="username"
                  class="form-control form-control-sm"
                  v-model="subuserData.username"
                />
              </div>
            </div>
            <div class="form-group row">
              <label
                for="iptContact"
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
                >{{ $t("app.密码：") }}</label
              >
              <div class="col-md-4 col-sm-12">
                <input
                  type="text"
                  name="password"
                  id="password"
                  class="form-control form-control-sm"
                  v-model="subuserData.password"
                />
              </div>
              <label
                for="iptPosition"
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
                >{{ $t("subuser.手机号：") }}</label
              >
              <div class="col-md-4 col-sm-12">
                <input
                  type="text"
                  name="mobile"
                  id="mobile"
                  class="form-control form-control-sm"
                  v-model="subuserData.mobile"
                />
              </div>
            </div>
            <div class="form-group row">
              <label
                for="iptContact"
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
                >{{ $t("subuser.邮箱地址：") }}</label
              >
              <div class="col-md-4 col-sm-12">
                <input
                  type="text"
                  name="email"
                  id="email"
                  class="form-control form-control-sm"
                  v-model="subuserData.email"
                />
              </div>
              <label
                for="iptPosition"
                class="
                  col-md-2 col-sm-6 col-form-label
                  form-control-sm
                  text-right
                "
                >QQ：</label
              >
              <div class="col-md-4 col-sm-12">
                <input
                  type="text"
                  name="qq"
                  id="qq"
                  class="form-control form-control-sm"
                  v-model="subuserData.qq"
                />
              </div>
            </div>
            <div class="form-group row">
              <label
                for="iptPosition"
                class="
                  col-md-2 col-sm-6 col-form-label
                  form-control-sm
                  text-right
                "
                >{{ $t("subuser.加入角色组：") }}</label
              >
              <div class="col-md-4 col-sm-12">
                <select
                  class="form-control form-control-sm"
                  name="roleId"
                  id="roleId"
                  v-model="subuserData.roleId"
                >
                  <option value="0" disabled>{{ $t("order.请选择") }}</option>
                  <option
                    v-for="item in roleList"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row mg-b-0">
              <div
                v-show="statusShow"
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
              >
                {{ $t("mall.状态：") }}
              </div>
              <div v-show="statusShow" class="col-md-4 col-sm-12">
                <div class="form-check form-check-inline pd-r-10">
                  <label class="rdiobox">
                    <input
                      type="radio"
                      name="status"
                      id="substart0"
                      value="1"
                      v-model="subuserData.status"
                    />
                    <span>{{ $t("mall.启用") }}</span>
                  </label>
                </div>
                <div class="form-check form-check-inline pd-r-10">
                  <label class="rdiobox">
                    <input
                      type="radio"
                      name="status"
                      id="substop1"
                      value="2"
                      v-model="subuserData.status"
                    />
                    <span>{{ $t("mall.停用") }}</span>
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="
              btn btn-primary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            @click="save"
          >
            {{ $t("subuser.保存") }}
          </button>
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("subuser.关闭") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: [Object, String],
      default() {
        return {};
      },
    },
    roleList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      statusShow: false,
      id: "",
      subuserData: {
        qq: "",
        name: "",
        username: "",
        password: "",
        mobile: "",
        email: "",
        roleId: 0,
        status: 1,
      },
    };
  },
  watch: {
    item() {
      this.id = this.item.id;
      this.subuserData.name = this.item.name;
      this.subuserData.qq = this.item.qq;
      this.subuserData.username = this.item.username;
      this.subuserData.password = this.item.password;
      this.subuserData.mobile = this.item.mobile;
      this.subuserData.email = this.item.email;
      this.subuserData.roleId = this.id ? this.item.roleId : 0;
      this.subuserData.status = this.item.status;
      this.statusShow = this.id ? true : false;
    },
  },
  methods: {
    save() {
      if (this.$parent.loading) return;
      let form = $("#modalAddSubUserBySupplier form");
      form.validate({
        rules: {
          name: {
            required: true,
          },
          username: {
            required: true,
            minlength: 3,
            maxlength: 100,
            usern: true,
          },
          password: {
            minlength: 6,
          },
          mobile: {
            isMobile: true,
          },
          email: {
            email: true,
          },
        },
        messages: {
          name: {
            required: this.$t("subuser.姓名必须输入"),
          },
          username: {
            required: this.$t("subuser.用户名必须输入"),
            minlength: this.$t("subuser.最少要输入3个字符"),
            maxlength: this.$t("subuser.最多可以输入100个字符"),
          },
          password: {
            minlength: this.$t("subuser.密码不少于6位"),
          },
          mobile: {
            isMobile: this.$t("subuser.输入有效的电话号码"),
          },
          email: {
            email: this.$t("subuser.输入正确的邮箱地址"),
          },
        },
        ignore: "",
        errorElement: "span",
        errorClass: "ipt-error",
        errorPlacement: function (error, element) {
          console.log(element);
          let nextEl = $(element).next();
          if (nextEl.length) {
            $(element).parent().append(error);
          } else {
            error.insertAfter(element);
          }
        },
      });
      if (form.valid()) {
        this.$parent.loading = true;
        let param1 = {
          username: this.subuserData.username,
          ids: this.id,
          password: this.subuserData.password,
          name: this.subuserData.name,
          mobile: this.subuserData.mobile,
          email: this.subuserData.email,
          roleId: this.subuserData.roleId,
          status: this.subuserData.status,
          qq: this.subuserData.qq,
        };
        let param2 = {
          username: this.subuserData.username,
          password: this.subuserData.password,
          name: this.subuserData.name,
          mobile: this.subuserData.mobile,
          email: this.subuserData.email,
          roleId: this.subuserData.roleId,
          qq: this.subuserData.qq,
        };
        let apiUrl;
        let param;
        let msg;
        msg = this.id
          ? this.$t("subuser.修改成功")
          : this.$t("subuser.新建子账号成功");
        apiUrl = this.id
          ? "api.SubUser.changeByUser"
          : "api.SubUser.insertByUser";
        param = this.id ? param1 : param2;
        $.api_call(apiUrl, param, (r) => {
          this.$parent.loading = false;
          if (r.ErrorCode == "9999") {
            $("#modalAddSubUserBySupplier").modal("hide");
            ShowTip(msg, "success");
            //恢复初始
            this.subuserData = {
              qq: "",
              name: "",
              username: "",
              password: "",
              mobile: "",
              email: "",
              roleId: 0,
            };
            this.$parent.getSubuserList(); //保存完成取一次数据
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(vm);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        });
      }
    },
  },
};
</script>